import { useCallback } from 'react';
import TagManager from 'react-gtm-module';
import gtagService from '../services/GTAG';

const useGoogleTagManager = (gtmId) => {
  const initGoogleTagManager = useCallback(() => {
    gtagService.initialize(gtmId);
  }, [gtmId]);

  const gtagEvent = useCallback((event, payload) => {
    return gtagService.gtagEvent(event, payload);
  }, []);

  /**
   * Clear the previous ecommerce object accocrding to docs
   * dataLayer.push({ ecommerce: null });
   */
  const gtagEcommerceClear = useCallback(() => {
    return TagManager.dataLayer({
      dataLayer: { ecommerce: null },
    });
  }, []);

  /**
   * @param {string} listingId
   * @param {string} listingName
   * @param {number} totalPrice
   * @param {string} currency
   * @param {string} checkInDate
   * @param {string} checkOutDate
   * @param {number} numberOfGuests
   * @param {string} pointOfSale
   */
  const gtagEcommerceViewItem = useCallback((data) => {
    gtagService.gtagEcommerceViewItem(data);
  }, []);

  /**
   * {number} data.totalPrice
   * {string} data.listingId
   * {string} data.listingName
   * {string} data.currency
   * {string} data.checkInDate
   * {string} data.checkOutDate
   * {string} data.numberOfGuests
   * {string} data.pointOfSale
   */
  const gtagEcommerceBeginCheckout = useCallback((data) => {
    gtagService.gtagEcommerceBeginCheckout(data);
  }, []);

  /**
   * {string} data.reservationId
   * {number} data.totalPrice
   * {string} data.listingId
   * {string} data.listingName
   * {string} data.currency
   * {string} data.checkInDate
   * {string} data.checkOutDate
   * {string} data.numberOfGuests
   * {string} data.pointOfSale
   */
  const gtagEcommercePurchase = useCallback((data) => {
    gtagService.gtagEcommercePurchase(data);
  }, []);

  return {
    initGoogleTagManager,
    gtagEvent,
    gtagEcommerceClear,
    gtagEcommerceViewItem,
    gtagEcommerceBeginCheckout,
    gtagEcommercePurchase,
  };
};

export default useGoogleTagManager;
